module.exports = __webpack_public_path__ + "img/Results.6959cb98.svg";